(function () {
  if (window.SkylitGalleryWall) return;

  var params = new URLSearchParams(window.location.search);
  var wallId = (params.get('gallery_wall') || '').replace(/[^a-zA-Z0-9_-]/g, '').slice(0, 80);
  var slot = (params.get('gallery_slot') || '').replace(/[^0-9]/g, '').slice(0, 2);

  function active() { return !!wallId && slot !== ''; }
  // Gallery wall journey log (admin /api/gallery-wall/event). text/plain +
  // keepalive: no CORS preflight, and it survives the redirect back to the wall.
  function wallEvent(event, props, orderId) {
    if (!active()) return;
    try {
      fetch('https://admin.skylitstudio.co.uk/api/gallery-wall/event', {
        method: 'POST', keepalive: true, headers: { 'Content-Type': 'text/plain' },
        body: JSON.stringify({ wall_id: wallId, event: event, order_id: orderId || null, props: Object.assign({}, props || {}, { at: Date.now() }) })
      }).catch(function () {});
    } catch (e) {}
  }
  var product = (window.location.pathname.split('/products/')[1] || '').split(/[/?#]/)[0].slice(0, 80);
  var addedOrders = {};
  function applyProperties(properties) {
    if (!active() || !properties) return properties;
    properties._gallery_wall_id = wallId;
    properties._gallery_wall_slot = slot;
    var orderId = properties._OrderID || properties.OrderID || '';
    if (orderId && !addedOrders[orderId]) {
      addedOrders[orderId] = true;
      wallEvent('customiser_added', { product: product, slot: Number(slot) }, orderId);
    }
    return properties;
  }
  function destination() {
    if (!active()) return '/cart';
    return '/pages/gallery-wall?returned=1&gallery_wall=' + encodeURIComponent(wallId) +
      '&gallery_slot=' + encodeURIComponent(slot);
  }
  // Every customiser's add-to-cart button, as it is rendered today. Only the
  // words "Add to cart" / "Add to basket" are swapped, inside whichever text
  // node holds them, so prices (YOR), arrows and other states ("Confirm
  // edits", "Adding...", the family moon's "Select Locations") are untouched.
  var BUTTONS = [
    '#sm2-add-to-cart',             // star map
    '.cust-footer-btn--submit',     // moon (shared customiser footer)
    '.h-submit__form',              // family moon
    '.lm-add-to-cart-btn',          // location map
    '#nl-add',                      // your name from orbit
    '#add-to-cart-btn'              // custom print
  ];
  var CART_WORDS = /add to (cart|basket|bag)/i;
  function relabel() {
    if (!active()) return;
    document.documentElement.classList.add('gallery-wall-return');
    BUTTONS.forEach(function (selector) {
      document.querySelectorAll(selector).forEach(function (button) {
        var walker = document.createTreeWalker(button, NodeFilter.SHOW_TEXT);
        var node;
        while ((node = walker.nextNode())) {
          if (CART_WORDS.test(node.nodeValue)) { node.nodeValue = node.nodeValue.replace(CART_WORDS, 'Add to gallery wall'); return; }
        }
      });
    });
  }
  function prefillFamilyMoon() {
    if (!active() || !/moon-phase/i.test(window.location.pathname)) return;
    var date = params.get('prefill_date');
    var targetYear = date && /^\d{4}-\d{2}-\d{2}$/.test(date) ? date.split('-')[0] : '';
    var lat = parseFloat(params.get('prefill_lat'));
    var lng = parseFloat(params.get('prefill_lng'));
    var place = (params.get('prefill_place') || '').slice(0, 80);
    var tries = 0;
    var timer = setInterval(function () {
      tries++;
      var day = document.querySelector('.h-bear-dates[data-moon="1"]');
      var month = document.querySelector('.h-bear-months[data-moon="1"]');
      var year = document.querySelector('.h-bear-years[data-moon="1"]');
      if (!day || !month || !year || (targetYear && !year.querySelector('option[value="'+targetYear+'"]'))) { if (tries > 40) clearInterval(timer); return; }
      clearInterval(timer);
      if (date && /^\d{4}-\d{2}-\d{2}$/.test(date)) {
        var parts = date.split('-');
        day.value = String(parseInt(parts[2], 10));
        month.value = String(parseInt(parts[1], 10) - 1);
        year.value = parts[0];
        year.dispatchEvent(new Event('change', { bubbles: true }));
        if (window.hUserSelectedDates) window.hUserSelectedDates.moon1 = true;
      }
      if (isFinite(lat) && isFinite(lng)) {
        ['#h-address_form1_moon1','#h-custom_address_moon1','#h-custom_location_moon1'].forEach(function (s) { var el=document.querySelector(s);if(el)el.value=place; });
        var label=document.getElementById('h-moon-location-1');if(label)label.textContent=place;
        if (window.hMoonInstances && window.hMoonInstances[1]) window.hMoonInstances[1].currentLocation={lat:lat,lng:lng,name:place};
        if (window.hUserEnteredLocations) window.hUserEnteredLocations.moon1 = true;
      }
      if (window.updateHAddToCartButtonText) window.updateHAddToCartButtonText();
    }, 400);
  }
  window.SkylitGalleryWall = {
    active: active,
    wallId: wallId,
    slot: slot,
    applyProperties: applyProperties,
    destination: destination,
    relabel: relabel
  };
  wallEvent('customiser_opened', { product: product, slot: Number(slot) }, (params.get('order_id') || '').replace(/[^a-zA-Z0-9_-]/g, '').slice(0, 64));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', relabel);
  else relabel();
  window.addEventListener('load', function () { setTimeout(relabel, 1200); prefillFamilyMoon(); });
  if (active() && window.MutationObserver) {
    var queued = false;
    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () { queued = false; relabel(); });
    }).observe(document.documentElement, { subtree: true, childList: true, characterData: true });
  }
})();
